<template>
	<section id="#detalle-producto" class="product-info">
		<div class="container">
			<div class="row border-product-detail">
				<div class="col-sm-3">
					<h2 class="text-uppercase"><strong>Dimensiones</strong></h2>
					<img class="img-responsive center-block" :src="render_info_image" alt="silla esquema">
				</div>
				<div class="col-sm-3">
					<h3 class="text-uppercase"><strong>Características</strong></h3>
					<p class="text-product-detail">
						{{{ transform(render_product.caracteristics) }}}
					</p>
				</div>
				<div class="col-sm-3">
					<h3 class="text-uppercase"><strong>Materiales</strong></h3>
					<p class="text-product-detail">
						{{{ transform(render_product.materials) }}}
					</p>
				</div>
				<div class="col-sm-3">
					<h3 class="text-uppercase"><strong>Conoce más</strong></h3>
					<p class="text-product-detail">
						{{{ transform(render_product.know_more) }}}
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
	.row{
		margin: 0;
	}
	@media (max-width: 768px){
		.container{
			text-align: center;
		}
	}
</style>



<script>
import API from '../../store/api';
import { router } from '../../routes/routes';
import default_image from '../../images/default.jpg';
import { api_base } from '../../store/api';

export default {
	// ---- DATA ----

	data() {
		return {
			image: default_image
		}
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			product: state => state.current_product,
			size: state => state.current_product_variation
		}
	},

	// ---- RENDER ----

	computed: {
		render_product() {
			return this.product;
		},

		render_info_image() {
			let image = null;

			switch (this.size) {
				case 'S':
					if (!this.product.info_img_S) {
						return this.image;
					}

					return api_base + '/storage/' + this.product.info_img_S;
				case 'L':
					if (!this.product.info_img_L) {
						return this.image;
					}

					return api_base + '/storage/' + this.product.info_img_L;
				default:
					if (!this.product.info_img) {
						return this.image;
					}

					return api_base + '/storage/' + this.product.info_img;
			}
		}
	},

	methods: {
		transform (text) {
			let new_text = '';

			if (text)
				for (let i = 0, t = text; i < text.length; i++) {
					if (t[i] == ';') {
						new_text += '<br/>';
					} else {
						new_text += t[i];
					}
				}

			return new_text;
		}
	}
}
</script>




// WEBPACK FOOTER //
// Product-detail-info.vue?45c3bef4